import React, {useState,useEffect} from 'react';
import { Button, Col, Row } from 'reactstrap';
import FormInput from '../../../../../components/common/FormsInput/FormInput';
import { useDispatch, useSelector } from 'react-redux';
import { userProfileInit,userProfileSchema } from "./schema";
import { updateProfile } from "../../../../../context/actions/user";
import { Formik, Form } from "formik";
import { capitalizeFirstLetter } from '../../../../../utils/common';
import { roleItems } from '../../../../../utils/constants';

const ProfileForm = () => {
    const userDetail = useSelector((state) => state?.user?.user);
    const [subadminDisabled, setSubadminDisabled] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [payload, setPlayload] = useState({
        ...userProfileInit,
        email: userDetail?.email,
        phone: userDetail?.phone,
        fname: userDetail?.fname,
        lname: userDetail?.lname,
        address:userDetail?.address
      });

      useEffect(() => {
        setPlayload({
          ...userProfileInit,
          email: userDetail?.email,
          phone: userDetail?.phone,
          fname: userDetail?.fname,
          lname: userDetail?.lname,
          address:userDetail?.address,
          role: userDetail?.roles?.role?.roleName
        })
      }, [userDetail]);

      useEffect(()=>{
        if(userDetail?.role == "superadmin" || userDetail?.role == "subadmin"){
            setSubadminDisabled(true)
        }

        let number = userDetail?.phone?.replace(/\D/g, '')
        console.log(number)
      }, [userDetail])

      const dispatch = useDispatch()
      const submitForm = (params) => {
        delete params.role
        setDisabled(true)
          dispatch(updateProfile(params, (res) => {
            setDisabled(false)
          }))
      };
    return (
        <div className='profile-form-wrapper'>
            <Formik
                 initialValues={payload}
                enableReinitialize
                validationSchema={userProfileSchema}
                onSubmit={submitForm}
            >
                {(formik) => (<Form >
                    <Row>
                        <Col md='6'>
                            <FormInput type="text" id="firstName" name="fname" value={formik?.values?.fname} placeholder="First Name" label="First Name" disabled={subadminDisabled}/>
                        </Col>
                        <Col md='6'>
                            <FormInput type="text" id="lasttName" name="lname" value={formik?.values?.lname} placeholder="Last Name" label="Last Name" disabled={subadminDisabled}/>
                        </Col>
                        <Col md='6'>
                            <FormInput type="text" id="emailAddress" disabled={true}  name="email" value={formik?.values?.email} placeholder="Email Address" label="Email Address" />
                        </Col>
                        <Col md='6'>
                            <FormInput type="text" id="role" disabled={true}  name="role" value={formik?.values?.role ? capitalizeFirstLetter(formik?.values?.role) : userDetail?.role == roleItems[2] ? "Administrator" : "Team Member"} placeholder="Role" label="Role" />
                        </Col>
                        <Col md='6'>
                            <FormInput type="text" id="phoneNumber" name="phone" value={formik?.values?.phone} onChange={(event) => {
                              const inputPhoneNumber =
                                event.target.value.replace(/\D/g, "");
                              let formattedPhoneNumber = "";

                              if (inputPhoneNumber.length < 4) {
                                formattedPhoneNumber = `(${inputPhoneNumber}`;
                              } else if (inputPhoneNumber.length < 7) {
                                formattedPhoneNumber = `(${inputPhoneNumber.slice(
                                  0,
                                  3
                                )}) ${inputPhoneNumber.slice(3)}`;
                              } else {
                                formattedPhoneNumber = `(${inputPhoneNumber.slice(
                                  0,
                                  3
                                )}) ${inputPhoneNumber.slice(
                                  3,
                                  6
                                )}-${inputPhoneNumber.slice(6, 10)}`;
                              }

                              formik.setFieldValue(
                                "phone",
                                formattedPhoneNumber
                              );
                              formik.setFieldTouched("phoone", true);
                            }} placeholder="Phone Number" label="Phone Number" disabled={subadminDisabled}/>
                        </Col>
                        {/* <Col md='6'>
                            <FormInput type="text" id="address"  name="address" value={formik?.values?.address} placeholder="Address" label="Address" />
                        </Col> */}
                        <Col sm='12'>
                            <Button type="submit" disabled={disabled || subadminDisabled} color='primary'>
                                Update
                         </Button>
                        </Col>
                    </Row>
                </Form>
                )}
            </Formik>
        </div>
    );
}

export default ProfileForm;